exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input[data-v-770df868]{border-radius:8px;box-shadow:0 2px 4px rgba(0,0,0,.1);transition:border-color .3s}.input[data-v-770df868]:focus{border-color:#057d8d;outline:none}.container[data-v-770df868]{padding:2rem}.field[data-v-770df868]{margin-bottom:1.5rem}input.input[data-v-770df868]{margin-top:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-770df868","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sasisopa/EditAmbitSASISOPA.vue
// module id = 4056
// module chunks = 0